import { useContext } from 'react';
import { PopoverNextContext } from '../PopoverNext.context';
import type {
  FloatingArrowProps,
  MiddlewareData,
  UseFloatingReturn,
  UseInteractionsReturn,
} from '@floating-ui/react';
import type { PopoverNextProps } from '../PopoverNext.types';

export type PopoverNextContextValue = {
  portalRoot?: HTMLElement | null;
  interactions: UseInteractionsReturn;
  popoverStyles: React.CSSProperties;
  transitionStyles?: React.CSSProperties;
  transitionStatus?: 'unmounted' | 'initial' | 'open' | 'close';
  context: UseFloatingReturn['context'];
  arrowProps: FloatingArrowProps;
  middlewareData: MiddlewareData;
} & Pick<
  PopoverNextProps,
  | 'dataHook'
  | 'flip'
  | 'placement'
  | 'open'
  | 'skin'
  | 'overlay'
  | 'role'
  | 'id'
  | 'style'
  | 'onClick'
  | 'showArrow'
  | 'customArrow'
  | 'moveArrowTo'
  | 'contentClassName'
> &
  Required<
    Pick<PopoverNextProps, 'focusManagerEnabled' | 'appendTo' | 'zIndex'>
  >;

export const usePopoverNextContext = (): PopoverNextContextValue => {
  const context = useContext(PopoverNextContext);

  if (context === null) {
    throw new Error(
      '<PopoverNext.Trigger /> and <PopoverNext.Content /> components must be wrapped with <PopoverNext />',
    );
  }

  return context;
};
